module.exports = __webpack_public_path__ + "static/media/goHighLevelLight.6f242d48.png";